import React, { useEffect, useState } from "react";
import {
  RadioButton,
  Checkbox,
  NumericTextBox,
  RadioButtonChangeEvent,
  NumericTextBoxChangeEvent,
  CheckboxChangeEvent,
} from "@progress/kendo-react-inputs";
import {
  DatePickerChangeEvent,
  DateTimePicker,
  DateTimePickerChangeEvent,
} from "@progress/kendo-react-dateinputs";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import {
  Button,
  ChipList,
  ChipListChangeEvent,
} from "@progress/kendo-react-buttons";
import { KeyValuePair, Schedule } from "@mikros/library";
import { Error } from "@progress/kendo-react-labels";
import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../../utils/apiConfig";
import ApiServices from "../../../service/apiService";
import ErrorHandler from "../../../utils/errorConfig";

export interface DeliveryScheduleProps {
  schedule: Schedule;
  onStepperChange: (schedule: Schedule) => void;
  backStepper: () => void;
}

export function DeliverySchedule(props: DeliveryScheduleProps) {
  const intl = useIntl();

  const date1 = new Date();

  const frequencyData = [
    intl.formatMessage({ id: "schedule.deliverySchedule.hourly" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.daily" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.weekly" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.monthly" }),
  ];
  const time = [
    "1 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "2 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "3 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "4 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "5 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "6 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "7 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "8 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "9 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "10 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "11 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
    "12 " + intl.formatMessage({ id: "schedule.deliverySchedule.Noon" }),
    "1 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "2 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "3 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "4 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "5 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "6 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "7 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "8 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "9 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "10 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "11 " + intl.formatMessage({ id: "schedule.deliverySchedule.PM" }),
    "12 " + intl.formatMessage({ id: "schedule.deliverySchedule.AM" }),
  ];
  const hourly = [
    "1 " + intl.formatMessage({ id: "schedule.deliverySchedule.hour" }),
    "2 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "3 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "4 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "5 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "6 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "7 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "8 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "9 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "10 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "11 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "12 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "13 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "14 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
    "15 " + intl.formatMessage({ id: "schedule.deliverySchedule.hours" }),
  ];
  const monthly = [
    intl.formatMessage({ id: "schedule.deliverySchedule.1stOfMonth" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.1stMondayOfMonth" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.15thOfMonth" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.lastFridayOfMonth" }),
    intl.formatMessage({ id: "schedule.deliverySchedule.lastDayOfMonth" }),
  ];
  const weekly = [
    "1 " + intl.formatMessage({ id: "schedule.deliverySchedule.week" }),
    "2 " + intl.formatMessage({ id: "schedule.deliverySchedule.weeks" }),
    "3 " + intl.formatMessage({ id: "schedule.deliverySchedule.weeks" }),
    "4 " + intl.formatMessage({ id: "schedule.deliverySchedule.weeks" }),
    "5 " + intl.formatMessage({ id: "schedule.deliverySchedule.weeks" }),
  ];
  const daily = [
    "1 " + intl.formatMessage({ id: "schedule.deliverySchedule.day" }),
    "2 " + intl.formatMessage({ id: "schedule.deliverySchedule.days" }),
    "3 " + intl.formatMessage({ id: "schedule.deliverySchedule.days" }),
    "4 " + intl.formatMessage({ id: "schedule.deliverySchedule.days" }),
    "5 " + intl.formatMessage({ id: "schedule.deliverySchedule.days" }),
  ];
  const deliveryMethods: KeyValuePair[] = [
    {
      key: "WHATSAPP",
      value: intl.formatMessage({ id: "schedule.deliverySchedule.whatsapp" }),
    },
    {
      key: "EMAIL",
      value: intl.formatMessage({ id: "schedule.deliverySchedule.email" }),
    },
    {
      key: "TEAMS",
      value: intl.formatMessage({ id: "schedule.deliverySchedule.teams" }),
    },
    {
      key: "SLACK",
      value: intl.formatMessage({ id: "schedule.deliverySchedule.slack" }),
    },
  ];

  const onDaysOfWeek = [
    {
      text: "S",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.7",
      }),
    },
    {
      text: "M",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.1",
      }),
    },
    {
      text: "T",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.2",
      }),
    },
    {
      text: "W",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.3",
      }),
    },
    {
      text: "T",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.4",
      }),
    },
    {
      text: "F",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.5",
      }),
    },
    {
      text: "S",
      value: intl.formatMessage({
        id: "schedule.landingpage.frequency.REWE.6",
      }),
    },
  ];

  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [date, setDate] = useState<Date>(date1);
  const [isSchdlReqrd, setIsSchdlReqrd] = useState<boolean>();
  const [channels, setChannels] = useState<string[]>([]);
  const [timeZone, setTimeZone] = useState<string>();
  const [startDate, setStartDate] = useState<Date>(date);
  const [startHour, setStartHour] = useState<string>();
  const [every, setEvery] = useState<string>();
  const [frequency, setFrequency] = useState<string>();
  const [courseEnd, setCourseEnd] = useState<boolean>();
  const [remFlag, setRemFlag] = useState<boolean>();
  const [everyDatas, setEveryDatas] = useState<string[]>(hourly);
  const [everyOnWeeks, setEveryOnWeeks] = useState<string[]>([]);
  const [occurence, setOccurence] = useState<number>(0);
  const [errors, setErrors] = useState<any>({});
  const [currDate, setCurrDate] = useState<boolean>(false);
  const [cardCnt, setCardCnt] = useState<number>(1);
  const [asmntCnt, setAsmntCnt] = useState<number>(0);
  const [templateLanguage, setTemplateLanguage] = useState<string>(
    intl.formatMessage({ id: "schedule.course.templateLanguage.English" })
  );
  const [languageCode, setLanguageCode] = useState<string>(
    intl.formatMessage({ id: "schedule.course.languageCode.english" })
  );
  const [organizationChannel, setOrganizationChannel] = React.useState<any>();
  const [availableChannel, setAvailableChannel] = useState<any>();

  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  console.log("props.schedule.minCardCntChpt",props.schedule.minCardCntChpt)
console.log("props.schedule.assessQuesCnt",props.schedule.assessQuesCnt)
  console.log("organization details", organizationChannel);
  console.log(
    "organization channel whatsapp",
    organizationChannel?.distbAcc?.whatsApp?.enabled
  );
  console.log(
    "organization channel teams",
    organizationChannel?.distbAcc?.teams?.enabled
  );

  const templLangs = [
    intl.formatMessage({ id: "schedule.course.templateLanguage.English" }),
    intl.formatMessage({ id: "schedule.course.templateLanguage.Tamil" }),
    intl.formatMessage({ id: "schedule.course.templateLanguage.Hindi" }),
  ];
  const languageMapping: Record<string, string> = {
    English: intl.formatMessage({
      id: "schedule.course.languageCode.english",
    }),
    Tamil: intl.formatMessage({
      id: "schedule.course.languageCode.tamil",
    }),
    Hindi: intl.formatMessage({
      id: "schedule.course.languageCode.hindi",
    }),
  };
  const languageCodeToLanguage: Record<string, string> = {
    en_US: intl.formatMessage({
      id: "schedule.course.templateLanguage.English",
    }),
    ta: intl.formatMessage({ id: "schedule.course.templateLanguage.Tamil" }),
  };

  const [startDateTime, setStartDateTime] = useState<Date>();
  const [includeAssement, setIncludeAssements] = useState<boolean>(true);
  const [enableRetake, setEnableRetake] = useState<boolean>(true);
  const [benchMark, setBenchMark] = useState<number>(80);
  const [certificateFlag, setCertificateFlag] = useState<boolean>(false);
  const [certificationEnabled, setCertificationEnabled] =
    useState<boolean>(false);

  console.log("certification enabled value", certificationEnabled);

  console.log("certificate flag in delivery schedule", certificateFlag);

  console.log("print schedule required bool value", isSchdlReqrd);
  console.log("print rem flag reminder bool value", remFlag);

  console.log("include assessment value outside", includeAssement);
  const handleSelectedDeliveryTypeOption = (e: RadioButtonChangeEvent) => {
    setIsSchdlReqrd(e.value);
    if (!e.value) {
      let newDate = new Date();
      newDate.setMinutes(newDate.getMinutes() + 2);
      setStartDateTime(newDate);
    }
  };

  console.log("schedule details", props.schedule);
  console.log("cards per schedule", cardCnt);
  console.log("assessment cards per schedule", props.schedule.assessQuesCnt);
  console.log("card count per schedule", props.schedule.minCardCntChpt);

  useEffect(() => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/organization/channels`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("Data received from organization", data);

          //extracting enabled channels
          const enabledChannels = Object.keys(data[0].distbAcc).filter(
            (channel) => data[0].distbAcc[channel].enabled
          );
          console.log(
            "certification enabled value in use effect",
            data[0]?.featureAccess?.certification
          );
          setAvailableChannel(enabledChannels);
          setCertificationEnabled(data[0]?.featureAccess?.certification);
        });
    }
  }, []);

  // React.useEffect(() => {
  //   let api = ApiServices.getInstance();
  //   if (accountInstance.accntId) {
  //     api
  //       .makeRequest(`${accountInstance.accntId}/organization`, "GET")
  //       .then(async (data) => {
  //         if (data && data.errorMessage) {
  //           setErrorFlag(true);
  //           await errorInstance.updateErrorCode(data.errorMessage);
  //           return;
  //         }

  //         if (data) {
  //           data.whatAccessToken = data?.distbAcc?.whatsApp?.accTkn;
  //           data.whatsapp = data?.distbAcc?.whatsApp?.enabled;
  //           data.teams = data.distbAcc.teams.enabled;
  //           data.teamAccessToken = data.distbAcc.teams.accTkn;
  //           data.slack = data.distbAcc.slack.enabled;
  //           data.slackAccessToken = data.distbAcc.slack.accTkn;
  //           data.emailCheck = data.distbAcc.email.enabled;
  //           data.emailAccessToken = data.distbAcc.email.accTkn;

  //           // let a = new Date(parseInt(data?.validUpTo)).toString();

  //           console.log("organization form response in GET schedules", data);
  //           setOrganizationChannel(data);
  //           // setOrganizationData(data);
  //         }
  //       });
  //   }
  // }, []);

  useEffect(() => {
    const date = new Date();
    const currdt = new Date(startDate);
    if (
      date.getDate() === currdt.getDate() &&
      date.getMonth() === currdt.getMonth() &&
      date.getFullYear() === currdt.getFullYear()
    ) {
      setCurrDate(true);
    } else {
      setCurrDate(false);
    }
  }, [startDate]);

  console.log("available channels print", availableChannel);
  const handleSetChannels = (e: string) => {
    if (channels?.length === 0) {
      setChannels([e]);
      props.schedule.channels = [e];
    } else {
      let arr = channels;
      if (arr.includes(e)) {
        const index = arr.indexOf(e);
        arr.splice(index, 1);
        props.schedule.channels = [e];
        setChannels(arr);
      } else {
        arr.push(e);
        props.schedule.channels = [e];
        setChannels(arr);
      }
    }
  };

  const handleTemplateLanguage = (e: DropDownListChangeEvent) => {
    setTemplateLanguage(e.value);
    setLanguageCode(languageMapping[e.value]);
  };

  const handleTimezoneChange = (e: CheckboxChangeEvent) => {
    if (e.target.element?.checked) {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setTimeZone(userTimeZone);
    } else {
      setTimeZone(undefined);
    }
  };

  const trimTimeArray = (): string[] => {
    let updatedTime = time.slice(date.getHours(), time.length);
    return updatedTime;
  };

  const handleStartDate = (e: DatePickerChangeEvent) => {
    setStartDate(e.value!!);
  };

  const handleStartDateTime = (e: DateTimePickerChangeEvent) => {
    setStartDateTime(e.value!!);
  };

  const handleStartHour = (e: DropDownListChangeEvent) => {
    setStartHour(e.value);
  };

  const handleEveryChange = (e: DropDownListChangeEvent) => {
    setEvery(e.value);
  };

  const handleFrequency = (e: DropDownListChangeEvent) => {
    setFrequency(e.value.toUpperCase());
    if (
      e.value === intl.formatMessage({ id: "schedule.deliverySchedule.hourly" })
    ) {
      console.log("inside hourly of handle frequency");
      setEveryDatas(hourly);
    } else if (
      e.value === intl.formatMessage({ id: "schedule.deliverySchedule.daily" })
    ) {
      setEveryDatas(daily);
    } else if (
      e.value === intl.formatMessage({ id: "schedule.deliverySchedule.weekly" })
    ) {
      setEveryDatas(weekly);
      setEvery(" ");
    } else if (
      e.value ===
      intl.formatMessage({ id: "schedule.deliverySchedule.monthly" })
    ) {
      setEveryDatas(monthly);
    }
  };

  const handleCourseEnd = (e: RadioButtonChangeEvent) => {
    setCourseEnd(e.value);
  };
  const handleCertificateOption = (e: RadioButtonChangeEvent) => {
    console.log("inside handle certificate option");
    setCertificateFlag(e.value);
  };
  const handleRemFlagChange = (e: RadioButtonChangeEvent) => {
    console.log("entered reminder change flag event");
    setRemFlag(e.value);
  };

  const handleEveryOnWeeks = (e: ChipListChangeEvent) => {
    setEveryOnWeeks(e.value);
  };

  const handleOccurenceChange = (e: NumericTextBoxChangeEvent) => {
    setOccurence(e.value!!);
  };

  const handleAsmntCntChange = (e: NumericTextBoxChangeEvent) => {
    console.log("entered the asmnt change function");
    setAsmntCnt(e.value!!);
  };

  const handleBenchmarkChange = (e: NumericTextBoxChangeEvent) => {
    setBenchMark(e.value!!);
  };

  const handleCardCntChange = (e: NumericTextBoxChangeEvent) => {
    setCardCnt(e.value!!);
  };

  const validate = () => {
    if (
      startDateTime !== undefined &&
      courseEnd !== undefined &&
      channels.length !== 0 &&
      isSchdlReqrd !== undefined &&
      frequency !== undefined &&
      every !== undefined
    ) {
      return true;
    }
    let err: any = {};
    if (channels.length === 0) {
      err.channels = {
        error: intl.formatMessage({
          id: "schedule.deliverySchedule.chooseChannel",
        }),
      };
    }
    if (courseEnd === undefined) {
      err.courseEnd = {
        error: intl.formatMessage({
          id: "schedule.deliverySchedule.selectOption",
        }),
      };
    }
    if (isSchdlReqrd === undefined) {
      err.isSchdlReqrd = {
        error: intl.formatMessage({
          id: "schedule.deliverySchedule.selectOption",
        }),
      };
    }

    if (isSchdlReqrd === true) {
      if (frequency === undefined) {
        err.frequency = {
          error: intl.formatMessage({
            id: "schedule.deliverySchedule.selectFrequency",
          }),
        };
      }
      if (frequency?.toLowerCase() !== "weekly") {
        if (every === undefined) {
          err.every = {
            error: intl.formatMessage({
              id: "schedule.deliverySchedule.selectOption",
            }),
          };
        }
      }

      if (startDateTime === undefined) {
        err.time = {
          error: intl.formatMessage({
            id: "schedule.deliverySchedule.startDateAndTime",
          }),
        };
      }
    } else {
      if (channels.length !== 0 && courseEnd !== undefined) {
        return true;
      }
    }
    setErrors(err);
    return false;
  };

  useEffect(() => {
    if (props.schedule) {
      console.log(
        "i am entering useEffect of delivery schedule for benchmark score",
        benchMark
      );
      console.log(
        "i am entering  use effect of delivery schedule",
        enableRetake
      );
      setCardCnt(props.schedule.cardsPerSchedule);
      setAsmntCnt(props.schedule.assessQuesCnt);
      if (props.schedule.startDate) {
        setStartDateTime(new Date(props.schedule.startDate));
      } else {
        let dt = new Date();
        dt.setMinutes(dt.getMinutes() + 10);
        setStartDateTime(dt);
      }
      if (props.schedule.benchmarkScore) {
        console.log(
          "entered benchmark score if",
          props.schedule.benchmarkScore
        );
        setBenchMark(props.schedule.benchmarkScore);
      }
      if (!props.schedule.benchmarkScore) {
        setEnableRetake(false);
      }
      if (!props.schedule.isSchdlReqrd) {
        let date = new Date();
        setStartDate(date);
      } else {
        if (props.schedule.frequency?.toLowerCase() === "hourly") {
          setEveryDatas(hourly);
        } else if (props.schedule.frequency?.toLowerCase() === "daily") {
          setEveryDatas(daily);
        } else if (props.schedule.frequency?.toLowerCase() === "weekly") {
          setEveryDatas(weekly);
          setEveryOnWeeks(props.schedule.on!!);
        } else if (props.schedule.frequency?.toLowerCase() === "monthly") {
          setEveryDatas(monthly);
        }
      }
    }
  }, [props.schedule]);

  const handleCourseDataChange = () => {
    if (validate()) {
      let schedule: Schedule = props.schedule;
      schedule.isSchdlReqrd = isSchdlReqrd!!;
      schedule.endOption = {
        courseEnd: courseEnd!!,
        occurence: occurence,
      };
      if (timeZone !== undefined) {
        schedule.timeZone = timeZone;
      }
      if (isSchdlReqrd) {
        schedule.every = every;
        let newDate = new Date(startDateTime!!.toUTCString());
        newDate.setSeconds(0, 0);
        schedule.startDate = newDate.toUTCString();
        schedule.frequency = frequency!!;
        schedule.on = everyOnWeeks;
      } else {
        schedule.frequency = "PRECISELY";
        schedule.every = undefined;
        schedule.on = undefined;
        let newDate = new Date();
        newDate.setMinutes(newDate.getMinutes() + 2);
        newDate.setSeconds(0, 0);
        schedule.startDate = newDate.toUTCString();
      }

      schedule.cardsPerSchedule = cardCnt ? cardCnt : 1;
      schedule.sendChapEnd = true;
      schedule.assessmentFlag = true;
      schedule.assessFBReq = true;
      schedule.assessQuesCnt = asmntCnt ? asmntCnt : 0;
      schedule.enableRetake = enableRetake;
      schedule.benchmarkScore = enableRetake ? benchMark : undefined;
      schedule.assessmentPlacement = "ChapterEnd";
      schedule.languageCode = languageCode;
      schedule.isReminderReqrd = remFlag!!;
      schedule.certificateReq = certificateFlag;
      props.onStepperChange(schedule);
      // schedule.minCardCntChpt = props.onStepperChange(schedule);
    }
  };

  useEffect(() => {
    setIsSchdlReqrd(props.schedule.isSchdlReqrd);
    setRemFlag(props.schedule.isReminderReqrd);
    setCertificateFlag(props.schedule.certificateReq ? true : false);
    setFrequency(props.schedule.frequency);
    setEvery(props.schedule.every);
    setTemplateLanguage(languageCodeToLanguage[props.schedule.languageCode!!]);

    if (props.schedule.channels !== undefined) {
      setChannels(props.schedule.channels);
    }

    if (props.schedule.on !== undefined) {
      setEveryOnWeeks(props.schedule.on);
    }

    if (props.schedule.endOption.occurence !== undefined) {
      setOccurence(props.schedule.endOption.occurence);
    }
    setCourseEnd(props.schedule.endOption.courseEnd);
    setTimeZone(props.schedule.timeZone);

    if (props.schedule.startDate !== undefined) {
      const dt = new Date(Date.parse(props.schedule.startDate.split("T")[0]));
      const dts = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
      setStartDate(dts);
    }
  }, []);

  return (
    <div className="w-full h-full overflow-auto space-y-8">
      <div className="w-full">
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleMethod" />
        </h4>
        <Error>{errors.channels?.error}</Error>
        <div className="ps-20 pt-2 flex-row md:space-x-10 sm:space-x-5">
          {/* {deliveryMethods
            .filter((deliveryMethod) => {
              if (!organizationChannel) return false; // Ensure organizationChannel is available
              return (
                (deliveryMethod.key === "WHATSAPP" &&
                  organizationChannel.whatsapp) ||
                (deliveryMethod.key === "EMAIL" &&
                  organizationChannel.emailCheck) ||
                (deliveryMethod.key === "TEAMS" && organizationChannel.teams) ||
                (deliveryMethod.key === "SLACK" && organizationChannel.slack)
              );
            })
            .map((deliveryMethod, index) => (
              <span key={index}>
                <RadioButton
                  name="deliveryMethod"
                  label={deliveryMethod.value}
                  defaultChecked={
                    props.schedule.channels?.includes(deliveryMethod.key) ??
                    false
                  }
                  value={deliveryMethod.key}
                  onClick={() => handleSetChannels(deliveryMethod.key)}
                />
              </span>
            ))} */}

          {availableChannel?.map((channel: string, index: any) => {
            const deliveryMethod = deliveryMethods?.find(
              (method) => method.key === channel.toUpperCase()
            );
            if (!deliveryMethod) {
              return null; //skip if no matching delivery
            }
            return (
              <span key={index}>
                <RadioButton
                  name="deliveryMethod"
                  label={deliveryMethod.value}
                  defaultChecked={
                    props.schedule.channels?.includes(deliveryMethod.key) ??
                    false
                  }
                  value={deliveryMethod.key}
                  onClick={() => handleSetChannels(deliveryMethod.key)}
                />
              </span>
            );
          })}
        </div>
      </div>
      <div>
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleType" />
        </h4>
        <Error>{errors.isSchdlReqrd?.error}</Error>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="isSchdlReqrd"
            value={true}
            checked={isSchdlReqrd === true}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliveryScheduleTypeOption1",
            })}
            onChange={handleSelectedDeliveryTypeOption}
          />
        </div>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="isSchdlReqrd"
            value={false}
            checked={isSchdlReqrd === false}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliveryScheduleTypeOption2",
            })}
            onChange={handleSelectedDeliveryTypeOption}
          />
        </div>
      </div>
      <div className={!isSchdlReqrd ? "hidden" : ""}>
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleSelect" />
        </h4>
        <div className="ps-20 pt-2 flex items-center">
          <h5 className="font-bold mr-4">
            <FormattedMessage id="schedule.createSchedule.deliveryScheduleSelect.startDate" />
          </h5>
          <DateTimePicker
            min={
              new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes() + 10
              )
            }
            value={startDateTime}
            onChange={handleStartDateTime}
            className="w-[18%] mr-2"
          />

          <Checkbox
            className="ml-3 self-center"
            value={timeZone === undefined ? false : true}
            onChange={handleTimezoneChange}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliveryScheduleSelect.tz",
            })}
          />
        </div>
        <Error>{errors.time?.error}</Error>
        <div className="ps-20 pt-5 flex items-center">
          <h5 className="font-bold mr-4">
            <FormattedMessage id="schedule.createSchedule.deliveryScheduleSelect.freq" />
          </h5>
          <DropDownList
            data={frequencyData}
            className="w-[12%]"
            value={frequency}
            onChange={handleFrequency}
            defaultValue={intl.formatMessage({
              id: "schedule.deliverySchedule.Frequency",
            })}
          />
        </div>
        <Error>{errors.frequency?.error}</Error>
        {frequency?.toLowerCase() !== "weekly" && (
          <>
            <div className="ps-20 pt-5 flex items-center">
              <h5 className="ps-8 font-bold mr-4">
                <FormattedMessage id="schedule.createSchedule.deliveryScheduleSelect.every" />
              </h5>
              <DropDownList
                className="w-[12%]"
                value={every}
                data={everyDatas}
                onChange={handleEveryChange}
              />
            </div>
            <Error>{errors.every?.error}</Error>
          </>
        )}
        <div
          className={
            frequency === "WEEKLY" ? "ps-20 pt-5 flex items-center" : "hidden"
          }
        >
          <h5 className="ps-11 font-bold mr-4">
            <FormattedMessage id="schedule.createSchedule.deliveryScheduleSelect.on" />
          </h5>
          <ChipList
            selection="multiple"
            value={everyOnWeeks}
            data={onDaysOfWeek}
            onChange={handleEveryOnWeeks}
          />
        </div>
      </div>
      <div>
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleContent" />
        </h4>
        <div className="ps-20 pt-2 flex items-center">
          <h5 className="font-bold mr-11">
            <FormattedMessage id="schedule.createSchedule.deliveryScheduleContent.card" />
          </h5>
          <NumericTextBox
            className="mx-2 w-[7%]"
            min={1}
            // max={props.schedule.minCardCntChpt}
            max={props.schedule.maxCardCnt}
            value={cardCnt}
            defaultValue={1}
            onChange={handleCardCntChange}
          />
        </div>
        <div className="ps-20 pt-2 flex items-center">
          <Checkbox
            value={includeAssement}
            onClick={() => {
              console.log("include assessment value choosen", includeAssement);
              setIncludeAssements(!includeAssement);
              if (includeAssement === true) {
                setAsmntCnt(0);
                setEnableRetake(false);
              }
            }}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliveryScheduleContent.isAssementIncluded",
            })}
          />
        </div>
        <div className="ps-28 pt-2 flex items-center">
          <h5 className=" font-bold mr-4">
            <FormattedMessage id="schedule.createSchedule.deliveryScheduleContent.assessment" />
          </h5>
          <NumericTextBox
            disabled={!includeAssement}
            className="mx-2 w-[7%]"
            min={0}
            value={asmntCnt}
            max={props.schedule.assessQuesCnt}
            defaultValue={0}
            onChange={handleAsmntCntChange}
          />
        </div>
        <div className="ps-28 pt-2 flex items-center">
          <Checkbox
            value={enableRetake}
            disabled={!includeAssement}
            onClick={() => {
              setEnableRetake(!enableRetake);

              if (!enableRetake === false) {
                setBenchMark(80);
              }
            }}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliveryScheduleContent.isAssementIncluded.enableRetake",
            })}
          />
        </div>
        <div className="ps-36 pt-2 flex items-center">
          <h5 className=" font-bold mr-4">
            <FormattedMessage id="schedule.createSchedule.deliveryScheduleContent.isAssementIncluded.benchMark" />
          </h5>
          <NumericTextBox
            disabled={!enableRetake}
            className="mx-2 w-[7%]"
            min={0}
            value={benchMark}
            max={100}
            defaultValue={80}
            onChange={handleBenchmarkChange}
          />
        </div>
      </div>

      <div className="w-full">
        <h4 className="font-bold">
          <FormattedMessage id="schedule.templateLanguage" />
        </h4>

        <div className="ps-20">
          <DropDownList
            data={templLangs}
            className="w-[12%]"
            value={templateLanguage}
            onChange={handleTemplateLanguage}
            defaultValue={intl.formatMessage({
              id: "schedule.course.templateLanguage.English",
            })}
          />
        </div>
      </div>
      <div>
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleContent.remFlag" />
        </h4>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="remFlag"
            value={true}
            checked={remFlag === true}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliverScheduleContent.enableRemFlag",
            })}
            onChange={handleRemFlagChange}
          />
        </div>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="remFlag"
            value={false}
            checked={remFlag === false}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliverScheduleContent.disableRemFlag",
            })}
            onChange={handleRemFlagChange}
          ></RadioButton>
        </div>
      </div>
      {certificationEnabled && (
        <div>
          <h4 className="font-bold">
            {/* Certificate Required */}
            <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.certificateOption" />
          </h4>
          {
            <div className="ps-20 pt-2 flex items-center space-x-4">
              <RadioButton
                name="certificateFlag"
                value={true}
                checked={certificateFlag === true}
                label={intl.formatMessage({
                  id: "schedule.deliverySchedule.Yes",
                })}
                onChange={handleCertificateOption}
                className="flex items-center space-x-1"
              />
              <RadioButton
                name="certificateFlag"
                value={false}
                checked={certificateFlag === false}
                label={intl.formatMessage({
                  id: "schedule.deliverySchedule.No",
                })}
                onChange={handleCertificateOption}
                className="flex items-center space-x-1"
              ></RadioButton>
            </div>
          }
        </div>
      )}

      <div>
        <h4 className="font-bold">
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleEndDate" />
        </h4>
        <Error>{errors.courseEnd?.error}</Error>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="courseEnd"
            value={true}
            checked={courseEnd === true}
            label={intl.formatMessage({
              id: "schedule.createSchedule.deliveryScheduleEndOption1",
            })}
            onChange={handleCourseEnd}
          />
        </div>
        <div className="ps-20 pt-2 flex items-center">
          <RadioButton
            name="courseEnd"
            value={false}
            checked={courseEnd === false}
            onChange={handleCourseEnd}
          />
          <NumericTextBox
            className="mx-2 w-[7%]"
            min={0}
            value={occurence}
            defaultValue={0}
            onChange={handleOccurenceChange}
          />{" "}
          <FormattedMessage id="schedule.createSchedule.deliveryScheduleEndOption2" />
        </div>
      </div>

      <div className="flex justify-end w-full space-x-4 pb-[15%] pr-[25%]">
        <Button themeColor={"primary"} onClick={() => props.backStepper()}>
          {/* Back */}
          <FormattedMessage id="backButton"></FormattedMessage>
        </Button>
        <Button
          className={frequency === "" ? "hidden" : ""}
          themeColor={"primary"}
          onClick={handleCourseDataChange}
        >
          <FormattedMessage id="nextButton"></FormattedMessage>
        </Button>
      </div>
    </div>
  );
}
